<template>
  <div id="app">
      <div class="wrapper">
    <router-view></router-view>
      </div>
  </div>
</template>

<script>
export default {
  async created(){
    await this.$store.dispatch("initAuth");
    document.title = this.$store.getters.getCompanyName;
  },
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue